// extracted by mini-css-extract-plugin
export default {"title":"Ht8Qn"};